import React from 'react'
import {
  ButtonGroupWrapper,
  ButtonGroupItem,
  ButtonGroupDivider,
} from './ButtonGroup.styles'

function ButtonGroup({buttons = [], variant = 'default'}) {
  return (
    <ButtonGroupWrapper variant={variant}>
      {buttons.map((btn, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ButtonGroupDivider variant={variant} />}
          <ButtonGroupItem
            variant={variant}
            onClick={btn.onClick}
            disabled={btn.disabled}
          >
            {btn.icon && btn.icon}
            {btn.label}
          </ButtonGroupItem>
        </React.Fragment>
      ))}
    </ButtonGroupWrapper>
  )
}

export {ButtonGroup}
